<template>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="gh-component-modal-video"
      :show-close="false"
      :modal-append-to-body="false"
      :width="dialogWidth"
      >
      <video v-if="!isVimeo()" id="video" oncontextmenu="return false;" width="100%" height="100%" controls controlsList="nodownload">
        <source :src="resource" type="video/mp4">
      </video>
      <div v-else class="video-container">
        <iframe
          :src="videoUrl + '?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media'"
          allowfullscreen allowtransparency allow="autoplay">
        </iframe>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="close()" class="gh-button gh-button--silver">Close</el-button>
      </span>
    </el-dialog>
</template>

<script>
  export default {
    props: {
        play: {
            type: Boolean
        },

        resource: {
            type: String,
            required: true
        }
    },

    data () {
      return {
        dialogVisible: false,
        videoId: '',
        videoUrl: ''
      }
    },

    computed: {
      dialogWidth() {
        return this.device !=='widescreen' ? '85%' : '50%'
      },

    device() {
        return this.$store.getters['ui/getDevice'];
      }
    },

    methods: {
      isVimeo () {
        return this.resource.includes('vimeo')
      },

      playVideo () {
        this.dialogVisible = true

        if (this.isVimeo()) {
          let videoId = this.resource.split(':')[1]
          this.videoUrl = `https://player.vimeo.com/video/${videoId}`
        }
      },

      close () {
        this.dialogVisible = false

        this.$emit('closeVideoDialog')
      }
    },

    watch: {
      dialogVisible (value) {
        if (!value) {
          this.videoUrl = null

          if (!this.isVimeo()) {
            var vid = document.getElementById("video")
            vid.pause()
            vid.currentTime = 0
          }
        }
      },

      play (value) {
          if (value) {
              this.playVideo()
          }
      }
    }
  }
</script>
<style lang="scss">
.gh-component-modal-video {
    .gh-hide {
    display: none;
    }
    .el-dialog__header {
    display: none;
    }

    .el-dialog__body {
    width: 100%;
    height: 88%;
    }

    .video-container {
    position: relative;
    height: 0;
    overflow: hidden;
    min-height: 161px;
    }

    iframe {
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
    }
    @media (max-width: 600px){
    .video-container {
        margin-bottom: -1rem;
    }
    }
    @media (min-width: 375px){
    .video-container {
        min-height: 168px;
    }
    }
    @media (min-width: 411px){
    .video-container {
        min-height: 185px;
    }
    }
    @media (min-width: 414px){
    .video-container {
        min-height: 187px;
    }
    }
    @media (min-width: 480px){
    .video-container {
        min-height: 204px;
    }
    }
    @media (min-width: 500px){
    .video-container {
        min-height: 213px;
    }
    }
    @media (min-width: 550px){
    .video-container {
        min-height: 237px;
    }
    }
    @media (min-width: 600px){
    .video-container {
        min-height: 275px;
    }
    }
    @media (min-width: 667px){
    .video-container {
        min-height: 293px;
    }
    }
    @media (min-width: 700px){
    .video-container {
        min-height: 309px;
    }
    }
    @media (min-width: 736px){
    .video-container {
        min-height: 326px;
    }
    }
    @media (min-width: 768px){
    .video-container {
        min-height: 356px;
    }
    }
    @media (min-width: 800px){
    .video-container {
        min-height: 369px;
    }
    }
    @media (min-width: 854px){
    .video-container {
        min-height: 383px;
    }
    }
    @media (min-width: 991px){
    .video-container {
        min-height: 461px;
    }
    }
    @media (min-width: 1024px){
    .video-container {
        min-height: 478px;
    }
    }
    @media (min-width: 1112px){
    .video-container {
        min-height: 520px;
    }
    }
    @media (min-width: 1200px){
    .video-container {
        min-height: 548px;
    }
    }
    @media (min-width: 1216px){
    .video-container {
        min-height: 349px;
    }
    }
    @media (min-width: 1300px){
    .video-container {
        min-height: 354px;
    }
    }
    @media (min-width: 1366px){
    .video-container {
        min-height: 358px;
    }
    }
    @media (min-width: 1400px){
    .video-container {
        min-height: 382px;
    }
    }
    @media (min-width: 1500px){
    .video-container {
        min-height: 410px;
    }
    }
    @media (min-width: 1600px){
    .video-container {
        min-height: 439px;
    }
    }
    @media (min-width: 1700px){
    .video-container {
        min-height: 467px;
    }
    }
    @media (min-width: 1800px){
    .video-container {
        min-height: 490px;
    }
    }
    @media (min-width: 1902px){
    .video-container {
        min-height: 514px;
    }
    }
}
</style>
